import {axiosInstance} from './axiosInstance';

export * from './error.dto';
export * from './selection';
export * from './auth';
export * from './products';
export * from './categories';
export * from './orders';
export * from './reports';
export * from './payments';
export * from './employees';
export * from './person.dto';

export const setAccessToken = (token: string) => {
	const interceptorId = axiosInstance.interceptors.request.use((request) => {
		request.headers.Authorization = `Bearer ${token}`;

		return request;
	});

	return () => axiosInstance.interceptors.request.eject(interceptorId);
};
